import { Badge, CardMedia, SkeletonBlock, Typography, } from '@one-thd/sui-atomic-components';
import React, { Fragment } from 'react';
import { generateImageUrl } from '../../utils/general';
import { consolidateLineItems } from '../../utils/shared/LineItemUtils';
var itemQuantityBadge = function (itemQuantity) {
    var BADGE_LEFT_POSITIONS = {
        1: 'sui-left-9',
        2: 'sui-left-[3.3rem]',
    };
    var badgeLeftPosition = BADGE_LEFT_POSITIONS[itemQuantity.toString().length || 0] || 'sui-left-9';
    return (React.createElement(React.Fragment, null, itemQuantity <= 1 ? null : (React.createElement("div", { className: "sui-absolute sui-bottom-[3rem] ".concat(badgeLeftPosition) },
        React.createElement(Badge, { variant: "strong", style: {
                fontSize: '12px',
                height: '23px',
                minWidth: '23px',
            }, size: "base", color: "primary" }, itemQuantity > 99 ? '99+' : itemQuantity)))));
};
export var ProductImages = function (_a) {
    var lineItems = _a.lineItems, _b = _a.showAll, showAll = _b === void 0 ? false : _b, _c = _a.maxShow, maxShow = _c === void 0 ? 4 : _c, _d = _a.variant, variant = _d === void 0 ? 'medium' : _d, _e = _a.isLoading, isLoading = _e === void 0 ? false : _e, _f = _a.hideCanceled, hideCanceled = _f === void 0 ? false : _f;
    if (isLoading) {
        if (variant === 'small') {
            return (React.createElement("div", { className: "sui-flex sui-gap-2" },
                React.createElement(SkeletonBlock, { height: 8, width: 8 }),
                React.createElement(SkeletonBlock, { height: 8, width: 8 }),
                React.createElement(SkeletonBlock, { height: 8, width: 8 })));
        }
        return (React.createElement("div", { className: "sui-flex sui-gap-2" },
            React.createElement(SkeletonBlock, { height: 12, width: 12 }),
            React.createElement(SkeletonBlock, { height: 12, width: 12 }),
            React.createElement(SkeletonBlock, { height: 12, width: 12 })));
    }
    var imageSize = {
        small: '32px',
        medium: '48px',
        large: '48px',
    }[variant];
    var filteredLineItems = lineItems === null || lineItems === void 0 ? void 0 : lineItems.filter(function (item) { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.parentLine) === null || _a === void 0 ? void 0 : _a.relationType) !== 'COMBO'; });
    var newLineItems = consolidateLineItems(filteredLineItems, hideCanceled);
    return (React.createElement("div", null, (lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) > 0 ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-flex ".concat({
                small: 'sui-gap-[6px]',
                medium: 'sui-gap-[16px]',
                large: 'sui-gap-4',
            }[variant]) }, newLineItems === null || newLineItems === void 0 ? void 0 : newLineItems.map(function (lineItem, index) {
            var _a, _b, _c, _d, _e;
            if (lineItem === undefined)
                return null;
            var itemQuantity = (lineItem === null || lineItem === void 0 ? void 0 : lineItem.statusDescription) === 'Returned'
                ? lineItem === null || lineItem === void 0 ? void 0 : lineItem.returnedQuantity
                : (_d = (_c = (_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.currentQuantity) !== null && _a !== void 0 ? _a : lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity) !== null && _b !== void 0 ? _b : lineItem === null || lineItem === void 0 ? void 0 : lineItem.originalOrderedQuantity) !== null && _c !== void 0 ? _c : lineItem === null || lineItem === void 0 ? void 0 : lineItem.orginalOrderedQuantity) !== null && _d !== void 0 ? _d : lineItem === null || lineItem === void 0 ? void 0 : lineItem.qtyToPrint;
            if (itemQuantity === undefined)
                return null;
            return (React.createElement(Fragment, { key: index },
                showAll && (React.createElement("div", { className: "sui-flex sui-items-center sui-relative", style: {
                        width: imageSize,
                        height: imageSize,
                    } },
                    React.createElement("div", { style: {
                            overflow: 'hidden',
                            width: imageSize,
                            height: imageSize,
                        } },
                        React.createElement(CardMedia, { src: generateImageUrl(lineItem), alt: lineItem
                                ? lineItem === null || lineItem === void 0 ? void 0 : lineItem.description
                                : 'Unavailable image' })),
                    variant !== 'small' && itemQuantityBadge(itemQuantity))),
                !showAll && index < maxShow - 1 && (React.createElement("div", { className: "sui-flex sui-items-center sui-relative", style: {
                        marginTop: '8px',
                        width: imageSize,
                        height: imageSize,
                    } },
                    React.createElement("div", { style: {
                            overflow: 'hidden',
                            width: imageSize,
                            height: imageSize,
                        } },
                        React.createElement(CardMedia, { src: generateImageUrl(lineItem), alt: lineItem
                                ? lineItem === null || lineItem === void 0 ? void 0 : lineItem.description
                                : 'Unavailable image' })),
                    variant !== 'small' && itemQuantityBadge(itemQuantity))),
                !showAll && index === maxShow - 1 && (React.createElement(React.Fragment, null, (lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) === maxShow ? (React.createElement("div", { className: "sui-relative", style: {
                        width: imageSize,
                        height: imageSize,
                    } },
                    React.createElement("div", { style: {
                            overflow: 'hidden',
                            width: imageSize,
                            height: imageSize,
                        } },
                        React.createElement(CardMedia, { src: generateImageUrl(lineItem), alt: lineItem
                                ? lineItem === null || lineItem === void 0 ? void 0 : lineItem.description
                                : 'Unavailable image' })),
                    variant !== 'small' &&
                        itemQuantityBadge(itemQuantity))) : (React.createElement("div", { className: "sui-bg-subtle sui-flex sui-justify-center sui-items-center", style: {
                        width: imageSize,
                        height: imageSize,
                        borderRadius: '4px',
                    } },
                    React.createElement(Typography, null, "+".concat(((_e = lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) !== null && _e !== void 0 ? _e : 0) - (maxShow - 1))))))),
                !showAll && index > maxShow - 1 && null));
        })))) : null));
};
